import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle11() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article11" headerImage="solarfarm.jpg" photographer=" Mark Stebnicki" />
        <Footer />
    </div>
  )
}
